import { token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const baseStyles = [
  css`
    :where(.player-container) {
      display: block;
      inline-size: 100%;
    }
    :where(.placeholder-container) {
      position: relative;
    }
    :where(.placeholder-image) {
      inline-size: 100%;
    }
    :where(.placeholder-button) {
      align-items: center;
      background-color: ${token('media-player-button-background-default')};
      border: 0 none;
      color: ${token('text-inverted')};
      cursor: pointer;
      display: flex;
      justify-content: center;

      &:hover {
        background-color: ${token('media-player-button-background-hover')};
      }
    }
  `,
];
